module.exports = __webpack_public_path__ + "img/five4Orange.bd57d806.jpg";